<script>
import { required } from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify';
import CoordinateMapModal from './coordinate_map_modal.vue';

export default {
  name: 'CreateModal',
  components: { CoordinateMapModal },
  props: ["list"],
  data() {
    return {
      form: {},
      ilList: [],
      popList: [],
      submitted: false,
      loading: false,
      title: "Verici Ekle",
      mapOpen: 0,
    };
  },
  validations: {
    form: {
      name: { required },
    },
  },
  watch: {
    list(props) {
      this.form = { ...props };
      this.title = this.form.id ? "Verici Güncelle" : "Verici Ekle";
    },
  },
  mounted() {
    this.setSelected({ id: 0 }, 'il');
    this.getPopList();
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return;
      }

      if (this.form.id) this.update();
      else this.create();

      this.$emit('loadItems');
      this.submitted = false;
    },
    create() {
      this.$http.post('/transmitter/store', this.form)
        .then(resp => {
          this.form = {};
          this.loading = false;
          return notify.success(resp.data.message);
        })
        .catch(() => { this.loading = false; });
    },
    update() {
      this.$http.put('/transmitter/' + this.form.id, this.form)
        .then(resp => {
          this.loading = false;
          return notify.success(resp.data.message);
        })
        .catch(() => { this.loading = false; });
    },
    remove(id) {
      this.$http.delete('/transmitter/' + id)
        .then(resp => {
          this.loading = false;
          if (resp.data.code !== 100) return notify.error(resp.data.message);
          return notify.success(resp.data.message);
        })
        .catch(() => { this.loading = false; });
    },
    openMap() {
      this.mapOpen = Date.now();
    },
    onCoordinateConfirm(coord) {
      this.form = { ...this.form, coordinate: coord || null };
    },
    close() {
      this.$parent.$bvModal.hide('modal-scoped');
    },
    async setSelected(val, event) {
      const object = event + 'List';
      const { id } = val;
      const response = await this.$http.post(`/address/${event}/${id}`);
      if (response.data.error) return;
      this[object] = response.data;
    },
    getPopList() {
      this.$http.post('/transmitter/groups?search=true')
        .then(response => { this.popList = response.data; });
    },
  },
};
</script>

<template>
  <div>
    <CoordinateMapModal
      modal-id="verici_coordinate_map_modal"
      title="Verici Konumu Seç"
      :open="mapOpen"
      :value="form.coordinate || ''"
      @confirm="onCoordinateConfirm"
    />

    <b-modal id="modal-scoped" :title="title" no-close-on-backdrop hide-footer>
      <form @submit.prevent="handleSubmit">
        <div class="row d-flex mb-1">
          <label class="col-sm-3 col-form-label">POP Noktası</label>
          <div class="col">
            <v-select
              label="name"
              v-model="form.transmitter_group_id"
              :options="popList"
              :reduce="val => val.id"
            >
              <span slot="no-options">Sonuç Bulunamadı</span>
            </v-select>
          </div>
        </div>

        <div class="row d-flex mb-1">
          <label class="col-sm-3 col-form-label">Verici İsmi</label>
          <div class="col">
            <input
              id="name"
              v-model="form.name"
              type="text"
              class="form-control"
              placeholder="Verici İsmi"
              :class="{ 'is-invalid': submitted && $v.form.name.$error }"
            />
            <div v-if="submitted && !$v.form.name.required" class="invalid-feedback">
              Bu alanı doldurmak zorunludur.
            </div>
          </div>
        </div>

        <div class="row d-flex mb-1">
          <label class="col-sm-3 col-form-label">Tip</label>
          <div class="col">
            <v-select
              label="name"
              v-model="form.type"
              :options="[{ id: 1, name: 'AP' }, { id: 2, name: 'LINK' }]"
              :reduce="loc => loc.id"
            >
              <span slot="no-options">Sonuç Bulunamadı</span>
            </v-select>
          </div>
        </div>

        <div class="row d-flex mb-1">
          <label class="col-sm-3 col-form-label">SSID</label>
          <div class="col">
            <input id="ssid" v-model="form.ssid" type="text" class="form-control" placeholder="SSID" />
          </div>
        </div>

        <div class="row d-flex mb-1">
          <label class="col-sm-3 col-form-label">M.A.C.</label>
          <div class="col">
            <input id="mac" v-model="form.mac" type="text" class="form-control" placeholder="M.A.C" />
          </div>
        </div>

        <div class="row d-flex mb-1">
          <label class="col-sm-3 col-form-label">İp Adresi</label>
          <div class="col">
            <input id="ip" v-model="form.ip" type="text" class="form-control" placeholder="İp Adresi" />
          </div>
        </div>

        <div class="row d-flex mb-1">
          <label class="col-sm-3 col-form-label">Username</label>
          <div class="col">
            <input id="username" v-model="form.username" type="text" class="form-control" placeholder="Username" />
          </div>
        </div>

        <div class="row d-flex mb-1">
          <label class="col-sm-3 col-form-label">Password</label>
          <div class="col">
            <input id="Password" v-model="form.password" type="text" class="form-control" placeholder="Password" />
          </div>
        </div>

        <div class="row d-flex mb-1">
          <label class="col-sm-3 col-form-label">Koordinat</label>
          <div class="col">
            <div class="input-group">
              <input
                v-model="form.coordinate"
                type="text"
                class="form-control"
                placeholder="Haritadan seçin"
                readonly
              />
              <button class="btn btn-outline-primary" type="button" @click="openMap">
                Haritadan Seç
              </button>
            </div>
          </div>
        </div>

        <div class="row d-flex mb-1">
          <label class="col-sm-3 col-form-label">Açıklama</label>
          <div class="col">
            <input id="explaine" v-model="form.explaine" type="text" class="form-control" placeholder="Açıklama" />
          </div>
        </div>

        <div class="d-flex justify-content-between mt-3">
          <div>
            <b-button variant="danger" v-if="form.id" @click="remove(form.id)">Sil</b-button>
          </div>
          <div>
            <b-button variant="light" @click="close()">Vazgeç</b-button>
            <b-button v-if="form.id" type="submit" variant="warning" class="ms-1">Güncelle</b-button>
            <b-button v-else type="submit" variant="success" class="ms-1" :disabled="loading">
              <span v-if="loading">
                <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
              </span>
              Oluştur
            </b-button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
